import { useState } from "react";
import { Link } from "react-router-dom";
import { faqList } from "@/mocks/faq";

export default function FaqPreview() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const preview = faqList.slice(0, 4);

  return (
    <section className="bg-accent-50 py-14 md:py-20">
      <div className="container-x grid grid-cols-1 gap-10 lg:grid-cols-2">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full border border-accent-200 bg-background-50 px-3 py-1 text-sm font-medium text-accent-700">
            <i className="ri-question-line"></i>
            常见问题
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            看番前的小疑问，小水来解答
          </h2>
          <p className="mt-4 max-w-md text-base leading-relaxed text-foreground-600">
            关于泡面番、短篇速刷、榜单规则，这里都有答案。还有疑问？欢迎随时联系我们。
          </p>
          <Link
            to="/faq"
            className="btn-pill mt-7 border border-accent-300 bg-background-50 text-accent-700 hover:bg-accent-100"
          >
            查看全部 FAQ <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="space-y-3">
          {preview.map((item, idx) => {
            const open = openIndex === idx;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-2xl border border-accent-100 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : idx)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                    {item.q}
                  </span>
                  <i
                    className={`${open ? "ri-subtract-line" : "ri-add-line"} shrink-0 text-lg text-accent-600 transition-transform`}
                  ></i>
                </button>
                {open && (
                  <p className="border-t border-accent-100 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}